import { createApiCall } from 'lib/base';

const FETCH_MARKET_CALENDAR_CREATE_API_ID =
  'DASHBOARD/FETCH_MARKET_CALENDAR_CREATE_API';

const apiCall = createApiCall(
  FETCH_MARKET_CALENDAR_CREATE_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/market-calendars`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
